import React, { useEffect, useState, useContext } from "react";
import Cookies from "js-cookie";

import Header from "../Header";
import Footer from "../Footer";

import { Select, Sort } from "../UI";
import Premium from "../Premium";

import { ReactComponent as AddSvg } from '../../assets/add_black.svg';
import { ReactComponent as ArrowSvg } from '../../assets/arrow_down.svg';
import { ReactComponent as DArrowSvg } from '../../assets/double-arrow.svg';

import users from '../../assets/users.svg';
import wireless from '../../assets/wireless.svg';
import time from '../../assets/time.svg';

import db from "../../firebase";
import { doc, getDocs, collection, onSnapshot, setDoc, query, where, order, orderBy } from "firebase/firestore";

import { AuthContext } from '../../context/AuthContext';
import { ProjectsContext } from '../../context/ProjectsContext';

import { useNavigate } from 'react-router-dom';

import ProjectList from '../ProjectList';

const Projects = () => {

    const { projects } = useContext(ProjectsContext);

    const [loading, setLoading] = useState(true);

    const [order, setOrder] = useState('');
    const [orderDirection, setOrderDirection] = useState(false);
    const [orderName, setOrderName] = useState('Name');

    const [status, setStatus] = useState(false);

    const { currentUser, user } = useContext(AuthContext);
    
    const handleFilter = (e) => {
        let status = e.value;
        setStatus(status);
        Cookies.set('status', status);
    }

    const [range, setRange] = useState(false);
    const handleFilterRange = (e) => {
        let range = e.value;
        setRange(range);
    }
    
    const sort = (order, direction, name) => {
        setOrder(order);
        setOrderDirection(direction);
        setOrderName(name);
    }
    const handleSort = (e) => {

        let value = e.value;
        let order = false;
        let direction = false;

        switch(value){
            case 'Name':
                order='name';
                direction='desc';
                break;
            case 'Latest':
                order='creation_date';
                direction='desc';
                break;
            case 'Oldest':
                order='creation_date';
                direction='asc';
                break;
        }

        //console.log(order);
        //console.log(direction);

        setOrder(order);
        setOrderDirection(direction);
        setOrderName(value);

        //Cookies.set('order', order);
        //Cookies.set('direction', direction);
    }
    

    //===

    useEffect(() => {

        /*
        let order = false;
        if (Cookies.get('order'))
            order = Cookies.get('order');
        else
            order = 'name';

        if (Cookies.get('status'))
            status = Cookies.get('status');
        else
            status = 'all';
        */

        setOrder('name');
        setStatus('all');

        
	}, []);

    useEffect(() => {

        //console.log('projects page');
        //console.log(projects);

        if (projects)
            setLoading(false);

	}, [projects]);
    
    const navigate = useNavigate();

    const [showPremium, setShowPremium] = useState(false);

    const createNew = async () => {

        if (user.account == 'premium' || projects.length < 1 )
            navigate('/create/');
        else
            setShowPremium(true);
    };    
    
    return (

        <div className="page page_projects">
        
        
            <Header />
            
            <main>
                <div className="content">
                
                    <ul className="breadcrumbs">
                        <li>
                            <a href="/">Home</a>
                        </li>
                    </ul>
                    
                    <div className="page__title">
                        <h1>Events</h1>

                        {projects && user && ((user.account == 'premium' || (projects && projects.length < 1)) ?

                            <div className="button button_add" onClick={createNew}>
                                Create new
                            </div>

                            :

                            <div className="unlock-block">
                                {projects.length}/1
                                <div className="button button_add unlock" onClick={createNew}>
                                    Unlock more projects
                                </div>
                            </div>
                        )}

                    </div>
                
                    <section className="projects">
                        <div className="filters">
                            <div className="left">
                                <div className="filter">
                                
                                    <Select 
                                        handleFilter={(e) => handleFilter(e)}
                                        prefix="Status" 
                                        options={[
                                            { value: 'all', label: 'All' },
                                            { value: 'publish', label: 'Publish' },
                                            { value: 'draft', label: 'Draft' },
                                        ]}
                                        placeholder={status}
                                       
                                    />
                                    
                                </div>

                                {/*
                                <div className="filter">
                                    
                                    <Select 
                                        prefix="Repository"
                                        options={[
    
                                        ]}
                                        placeholder="all"
                                        onChange={(e) => handleFilter('repository', e)}
                                    />
                                    
                                </div>
                                <div className="filter filter_environment">
    
                                    <Select 
                                        prefix="Environment"
                                        options={[
                                        ]}
                                        placeholder="all"
                                        onChange={(e) => handleFilter('environment', e)}
                                    />
                                    
                                </div>                                
                                */}
                                
                                <div className="sort">
                            
                                    <div className="filter filter_sort filter_users">
                                        <Sort
                                            order={order}
                                            name="Users" 
                                            value="users"
                                            image={[users]}
                                            sort={sort}
                                        />
                                    </div>

                                    <div className="filter filter_sort filter_activity">
                                        <Sort 
                                            order={order}
                                            name="Last activity" 
                                            value="last_activity"
                                            image={[wireless]} 
                                            sort={sort}
                                        />
                                    </div>
                                    
                                    {/*
                                    <div className="filter filter_sort filter_time">
                                        <Sort 
                                            name="Average time spent" 
                                            defaultValue="" 
                                            image={time}
                                            onChange={(e) => handleSort('time', e)}
                                        />
                                    </div>
                                    */}
                                </div>
                                
                            </div>
                            
                            <div className="right">
                            
                                <div className="filter filter_timerange">
    
                                    <Select
                                        prefix= "Time Range"
                                        options={[
                                            { value: 'All ranges', label: 'All ranges' },
                                            { value: 'Last 24 Hours', label: 'Last 24 Hours' },
                                            { value: 'Last Week', label: 'Last Week' },
                                            { value: 'Last Month', label: 'Last Month' },
                                        ]}
                                        placeholder="All ranges"
                                        handleFilter={(e) => handleFilterRange(e)}
                                    />


                                </div>
                                
                                <div className="filter filter_sort">
    
                                    <Select
                                        orderName='Options'
                                        order={order}
                                        prefix="Sort"
                                        options={[
                                            { value: 'Name', label: 'Name' },
                                            { value: 'Latest', label: 'Latest' },
                                            { value: 'Oldest', label: 'Oldest' },
                                        ]}
                                        placeholder={orderName}
                                        handleFilter={(e) => handleSort(e)}
                                    />

                                </div>
                            </div>
                            
                        </div>                
                        <div className="list">
                        
                            <ProjectList projects={projects} order={order} orderDirection={orderDirection} range={range} loading={loading} status={status}/>
                            
                        </div>

                        {projects && user && ((user.account == 'premium' || (projects && projects.length < 1)) ?

                            <div className="button_light" onClick={createNew}>
                                <AddSvg />
                                Create new
                            </div>

                            :

                            <div className="unlock-block">
                                {projects.length}/1
                                <div className="button button_add unlock" onClick={createNew}>
                                    Unlock more projects
                                </div>
                            </div>
                        )}

                        
                    </section>
                    
                </div>
            </main>
                
            <Footer />

            {
                showPremium &&
                    <Premium setShowPremium={setShowPremium} />
            }
        
        </div>
        
    )
        
}

export default Projects;
